import { useMemo, useState } from "react";
import { latestMovies } from "@/mocks/movies";
import MovieCard from "./MovieCard";

const filters = ["全部", "悬疑", "剧情", "奇幻", "犯罪", "爱情", "运动", "惊悚", "美食", "冒险"];

export default function MovieGridSection() {
  const [query, setQuery] = useState("");
  const [active, setActive] = useState("全部");

  const results = useMemo(() => {
    const kw = query.trim();
    return latestMovies.filter((m) => {
      const matchGenre = active === "全部" || m.genre === active;
      const matchKw =
        kw === "" ||
        m.title.includes(kw) ||
        m.desc.includes(kw) ||
        m.region.includes(kw);
      return matchGenre && matchKw;
    });
  }, [query, active]);

  return (
    <section id="latest" className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新电影
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">
            按上线时间与热度综合整理的新片片单，涵盖悬疑、剧情、奇幻、犯罪等多种题材，
            支持按片名搜索与题材筛选，快速锁定想看的那一部。
          </p>
        </div>
        <label className="relative w-full lg:w-80 shrink-0">
          <span className="sr-only">搜索影片</span>
          <i
            className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-lg text-foreground-400"
            aria-hidden="true"
          />
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="搜索片名、地区或简介关键词"
            className="w-full pl-11 pr-4 py-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
          />
        </label>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {filters.map((f) => {
          const isActive = f === active;
          return (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`px-3.5 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap cursor-pointer ${
                isActive
                  ? "bg-accent-500 text-background-50 font-semibold"
                  : "bg-background-50 text-foreground-700 border border-background-300 hover:border-accent-300 hover:text-accent-600"
              }`}
            >
              {f}
            </button>
          );
        })}
      </div>

      {results.length > 0 ? (
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
          {results.map((item) => (
            <MovieCard key={item.id} item={item} showYear />
          ))}
        </div>
      ) : (
        <div className="mt-10 flex flex-col items-center justify-center text-center py-14 rounded-xl border border-dashed border-background-300 bg-background-50">
          <i className="ri-emotion-sad-line text-4xl text-foreground-300" aria-hidden="true" />
          <p className="mt-3 text-sm text-foreground-700">没有找到符合「{query || active}」的影片</p>
          <button
            type="button"
            onClick={() => {
              setQuery("");
              setActive("全部");
            }}
            className="mt-4 px-4 py-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            重置筛选
          </button>
        </div>
      )}

      <p className="mt-6 text-xs text-foreground-500">
        当前显示 <span className="font-semibold text-foreground-800">{results.length}</span> 部影片，
        共收录 {latestMovies.length} 部新片。
      </p>
    </section>
  );
}